

import { useEffect, useState, useRef } from 'react';
import { BsPrinter, BsDownload, BsShieldCheck } from 'react-icons/bs';
import { useReactToPrint } from "react-to-print";
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import { toWords } from "number-to-words";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// export default function PaymentReceipt({ ac, paymentData }) {
//     console.log("activeCard>>>>>", ac);
//     console.log("paymentData>>>>>", paymentData);
//     const [paymentDetails, setpaymentdetails] = useState({});

//     function GetPaymentDtls() {
//         CommonAxiosGet(config.url.FAC_URL + 'paymentDetails').then((res) => {
//             if (res?.data?.scode === '01') {
//                 setpaymentdetails(res?.data?.paymentDetails[0] || {});
//             }
//         });
//     }

//     const amount = paymentDetails?.affl_fee || 0;
//     const amountInWords = amount
//         ? toWords(amount).charAt(0).toUpperCase() + toWords(amount).slice(1)
//         : "Zero";

//     const componentRef = useRef();

//     const handlePrint = useReactToPrint({
//         content: () => componentRef.current,
//         documentTitle: "PaymentReceipt",
//     });

//     const handleDownload = async () => {
//         const element = componentRef.current;
//         const canvas = await html2canvas(element, { scale: 2, useCORS: true });
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//         pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
//         pdf.save("PaymentReceipt.pdf");
//     };

//     useEffect(() => { GetPaymentDtls(); }, []);

//     return (
//         <div className="receipt-page">

//             {/* ── Action Buttons (excluded from print/PDF) ── */}
//             <div className="receipt-actions no-print">
//                 <button className="btn-receipt btn-dl" onClick={handleDownload}>
//                     <BsDownload size={14} /> Download PDF
//                 </button>
//                 <button className="btn-receipt btn-pr" onClick={handlePrint}>
//                     <BsPrinter size={14} /> Print
//                 </button>
//             </div>

//             {/* ── Receipt Card ── */}
//             <div className="receipt-card" ref={componentRef}>

//                 {/* Header */}
//                 <div className="receipt-header">
//                     <div>
//                         <h1 className="receipt-title">Payment Receipt</h1>
//                         <p className="receipt-subtitle">
//                             Commissionerate of Higher Education — Government of Andhra Pradesh
//                         </p>
//                     </div>
//                     <span className="receipt-badge">EOP 2026–27</span>
//                 </div>

//                 {/* Status Bar */}
//                 <div className="receipt-status-bar">
//                     <div className="status-item">
//                         <span className="status-label">Status</span>
//                         <span className="status-value success">&#10003; Payment Successful</span>
//                     </div>
//                     <div className="status-item">
//                         <span className="status-label">Transaction No</span>
//                         <span className="status-value">{paymentDetails.transaction_id || "—"}</span>
//                     </div>
//                     <div className="status-item">
//                         <span className="status-label">Reference No</span>
//                         <span className="status-value">{paymentDetails.reference_id || "—"}</span>
//                     </div>
//                     <div className="status-item">
//                         <span className="status-label">Date &amp; Time</span>
//                         <span className="status-value">{paymentDetails.entered_time || "—"}</span>
//                     </div>
//                 </div>

//                 {/* Body */}
//                 <div className="receipt-body">

//                     {/* College Details */}
//                     <p className="section-title">College Details</p>
//                     <div className="info-grid">
//                         <div className="info-cell">
//                             <div className="info-label">University</div>
//                             <div className="info-value">{paymentDetails.ub_name || "—"}</div>
//                         </div>
//                         <div className="info-cell">
//                             <div className="info-label">Institute Code</div>
//                             <div className="info-value">{paymentDetails.coll_code || "—"}</div>
//                         </div>
//                         <div className="info-cell span-2">
//                             <div className="info-label">College Name</div>
//                             <div className="info-value">{paymentDetails.inst_name || "—"}</div>
//                         </div>
//                     </div>

//                     {/* Payment Details */}
//                     <p className="section-title">Payment Details</p>
//                     <div className="info-grid" style={{ marginBottom: 16 }}>
//                         <div className="info-cell">
//                             <div className="info-label">Purpose</div>
//                             <div className="info-value">Application Fee for {ac} 2026-27</div>
//                         </div>
//                         <div className="info-cell">
//                             <div className="info-label">Payment Mode</div>
//                             <div className="info-value">Online</div>
//                         </div>
//                     </div>

//                     {/* Amount */}
//                     <div className="amount-row">
//                         <div>
//                             <div className="amount-label">Total Amount Paid</div>
//                             <div className="amount-words">{amountInWords} Rupees Only /-</div>
//                         </div>
//                         <div className="amount-value">₹{paymentData?.affl_fee}/-</div>
//                     </div>
//                 </div>

//                 {/* Footer */}
//                 <div className="receipt-footer">
//                     <span className="footer-note">
//                         This is a computer generated receipt. Signature is not required.
//                     </span>
//                     <BsShieldCheck size={28} color="#378ADD" />
//                 </div>
//             </div>
//         </div>
//     );
// }
export default function PaymentReceipt({ ac, paymentData }) {
    const details = paymentData || {};

    // Amount in words
    const amount = details.affl_fee || 0;
    const amountInWords = amount
        ? toWords(amount).charAt(0).toUpperCase() + toWords(amount).slice(1)
        : "Zero";

    // const componentRef = useRef();

    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    //     documentTitle: "PaymentReceipt",
    // });
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        documentTitle: "PaymentReceipt",
    });
    const handleDownload = async () => {
        const element = componentRef.current;
        const canvas = await html2canvas(element, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("PaymentReceipt.pdf");
    };

    return (
        <div className="receipt-page">
            {/* ── Action Buttons (excluded from print/PDF) ── */}
            <div className="receipt-actions no-print">
                <button className="btn-receipt btn-dl" onClick={handleDownload}>
                    <BsDownload size={14} /> Download PDF
                </button>
                <button className="btn-receipt btn-pr" onClick={handlePrint}>
                    <BsPrinter size={14} /> Print
                </button>
            </div>

            {/* ── Receipt Card ── */}
            <div className="receipt-card" ref={componentRef}>
                {/* Header */}
                <div className="receipt-header">
                    <div>
                        <h1 className="receipt-title">Payment Receipt</h1>
                        <p className="receipt-subtitle">
                            Commissionerate of Higher Education — Government of Andhra Pradesh
                        </p>
                    </div>
                    <span className="receipt-badge">{details.noc_type?.toUpperCase() || "EOP"} 2026–27</span>
                </div>

                {/* Status Bar */}
                <div className="receipt-status-bar">
                    <div className="status-item">
                        <span className="status-label">Status</span>
                        <span className="status-value success">&#10003; Payment Successful</span>
                    </div>
                    <div className="status-item">
                        <span className="status-label">Transaction No</span>
                        <span className="status-value">{details.transaction_id || "—"}</span>
                    </div>
                    <div className="status-item">
                        <span className="status-label">Reference No</span>
                        <span className="status-value">{details.reference_id || "—"}</span>
                    </div>
                    <div className="status-item">
                        <span className="status-label">Date &amp; Time</span>
                        <span className="status-value">{details.entered_time || "—"}</span>
                    </div>
                </div>

                {/* Body */}
                <div className="receipt-body">
                    {/* College Details */}
                    <p className="section-title">College Details</p>
                    <div className="info-grid">
                        <div className="info-cell">
                            <div className="info-label">University</div>
                            <div className="info-value">{details.ub_name || "—"}</div>
                        </div>
                        <div className="info-cell">
                            <div className="info-label">Institute Code</div>
                            <div className="info-value">{details.coll_code || "—"}</div>
                        </div>
                        <div className="info-cell span-2">
                            <div className="info-label">College Name</div>
                            <div className="info-value">{details.inst_name || "—"}</div>
                        </div>
                    </div>

                    {/* Payment Details */}
                    <p className="section-title">Payment Details</p>
                    <div className="info-grid" style={{ marginBottom: 16 }}>
                        <div className="info-cell">
                            <div className="info-label">Purpose</div>
                            <div className="info-value">Application Fee for {ac} 2026-27</div>
                        </div>
                        <div className="info-cell">
                            <div className="info-label">Payment Mode</div>
                            <div className="info-value">Online</div>
                        </div>
                    </div>

                    {/* Amount */}
                    <div className="amount-row">
                        <div>
                            <div className="amount-label">Total Amount Paid</div>
                            <div className="amount-words">{amountInWords} Rupees Only /-</div>
                        </div>
                        <div className="amount-value">₹{details.affl_fee || 0}/-</div>
                    </div>
                </div>

                {/* Footer */}
                <div className="receipt-footer">
                    <span className="footer-note">
                        This is a computer generated receipt. Signature is not required.
                    </span>
                    <BsShieldCheck size={28} color="#378ADD" />
                </div>
            </div>
        </div>
    );
}